<a target="_blank" [href]="document.url" *ngFor="let document of documents">
  <mat-icon aria-hidden="false" [attr.aria-label]="document.title">download</mat-icon>{{document.title}}
</a>
